import { render, staticRenderFns } from "./paymentForStockist.vue?vue&type=template&id=3bb5b2ea&"
import script from "./paymentForStockist.vue?vue&type=script&lang=js&"
export * from "./paymentForStockist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports